import { inject, Injectable, signal } from '@angular/core';
import { adminUserApi, adminUserDtos } from '@vectronic/openApi-admin';
import { BehaviorSubject, Observable, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminMapPreferencesService {
  private readonly api = inject(adminUserApi.MapPreferences);

  private readonly refresh$ = new BehaviorSubject<void>(undefined);

  readonly mapPreferences$ = this.refresh$.pipe(
    switchMap(() => this.api.getMapPreferences()),
    tap((prefs) => this.mapPreferences.set(prefs)),
    shareReplay(1),
  );

  readonly mapPreferences = signal<adminUserDtos.MapPreferences>(null);

  getMapPreferences(): Observable<adminUserDtos.MapPreferences> {
    return this.mapPreferences$;
  }

  refreshPreferences() {
    this.refresh$.next();
  }
}
